export default "__VITE_ASSET__CFskTUJ6__"